import { Box, Grid, Link, Typography } from "@mui/material";
import { Colors } from "../../Assets/colors";
import { Link as ReactLink } from "react-router-dom";

const BottomNavbar = () => {
  const BasicDivRow = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
  };
  return (
    <>
      <Box sx={{ background: Colors.SecondaryUSTColor }}>
        <Grid container>
          <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> HOME </Typography>
            </Link>
          </Grid>
          <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/about" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> ABOUT </Typography>
            </Link>
          </Grid>
          <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/news" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> NEWS </Typography>
            </Link>
          </Grid>
          <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/publications" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> PUBLICATIONS </Typography>
            </Link>
          </Grid>
          <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/projects" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> PROJECTS </Typography>
            </Link>
          </Grid>
          {/* <Grid item xs style={BasicDivRow}>
            <Link
              as={ReactLink}
              to={{ pathname: "/dashboards" }}
              variant="text"
              style={{ textDecoration: "none" }}
            >
              <Typography color={Colors.White}> DASHBOARDS </Typography>
            </Link>
          </Grid> */}
        </Grid>
      </Box>
    </>
  );
};

export default BottomNavbar;
